import { useEffect, useState } from 'react'
import { Card } from '@/components/ui/card'
import AuthLayout from '@/views/auth-layout'
import { useNavigate, useParams } from '@tanstack/react-router'
import { verifyEmailConfirm, AuthResponse } from '@/api/auth'
import { toast } from '@/hooks/use-toast'
import { useAuthStore } from '@/stores/authStore'
import { Route } from '@/routes/auth/verify-email-confirm.$uidb64.$token'

export default function VerifyEmailConfirmPage() {
  const nav = useNavigate()
  const { uidb64, token } = useParams({ from: Route.id })
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')

  useEffect(() => {
    async function confirm() {
      try {
        const v: AuthResponse = await verifyEmailConfirm(uidb64, token)
        if (v?.access) {
          const state = useAuthStore.getState()
          state.auth.setAccessToken(v.access)
          state.auth.setRefreshToken(v.refresh)
          state.auth.setUser(v.user)
        }
        setStatus('success')
        toast({ title: 'Email verified', description: 'Your email has been confirmed.' })
        nav({ to: '/dashboard' })
      } catch (e: any) {
        setStatus('error')
        toast({ variant: 'destructive', title: e?.response?.data?.error ?? 'Verification failed' })
      }
    }
    confirm()
  }, [uidb64, token, nav])

  return (
    <AuthLayout>
      <Card className='p-6'>
        <div className='flex flex-col space-y-2 text-center'>
          <h1 className='text-2xl font-semibold tracking-tight'>Verify email</h1>
          <p className='text-sm text-muted-foreground'>We are confirming your email address…</p>
        </div>
        <div className='pt-4 text-center'>
          {status === 'loading' && <p>Processing…</p>}
          {status === 'error' && <p>Link invalid or expired. Try resending from the app.</p>}
        </div>
      </Card>
    </AuthLayout>
  )
}